import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';
import { getInfoPrivacyEndpoint } from 'services/privacy/privacy.config';
import {
  GetInfoPrivacyResponse,
  InfoPrivacy,
} from 'services/privacy/privacy.types';

type PrivacyState = {
  infoPrivacy: InfoPrivacy[];
};

const initialState: PrivacyState = {
  infoPrivacy: [],
};

const privacyReducer = createReducer(initialState, (builder) =>
  builder.addCase(apiRequestSuccess, (state, action) => {
    const { payload } = action;

    if (payload.resourceId === getInfoPrivacyEndpoint) {
      const response: GetInfoPrivacyResponse = payload.response.data;

      const infoPrivacy = response.infoPrivacy;

      if (Array.isArray(infoPrivacy)) {
        state.infoPrivacy = infoPrivacy;
      }
      return;
    }
  }),
);

export default privacyReducer;
